import { CalendarView } from "PFApp/booking/types";
import React from "react";

import { useBookingsOverviewContext } from "../../../../context/bookings_overview_context";
import { useCalendarContext } from "../../../../context/calendar_context";
import { OVERBOOKINGS_HEIGHT } from "../../../calendar";
import BasicBar from "../../basic_bar";
import { OverbookingWithThreshold } from "../use_group_items_by_threshold";
import css from "./overbookings_bar.module.scss";
import { OverbookingsBarTooltips } from "./overbookings_bar_tooltips";

const BORDER_WIDTH = 1;

type OverbookingsBarProps = {
  overbookingsWithThreshold: OverbookingWithThreshold;
  left: number;
  duration: number;
  start: string;
  end: string;
};

export const OverbookingsBar = ({
  overbookingsWithThreshold,
  left,
  duration
}: OverbookingsBarProps): JSX.Element => {
  const {
    calendarData: { view }
  } = useBookingsOverviewContext();
  const { dayWidth } = useCalendarContext();
  const { threshold } = overbookingsWithThreshold;
  const borderWidth = ![CalendarView.BookingsOnly, CalendarView.Compressed].includes(view) ? BORDER_WIDTH : 0;
  const width = dayWidth * duration - borderWidth;

  return (
    <BasicBar
      left={left}
      width={width}
      className={css.overbookingBar}
      style={{ height: OVERBOOKINGS_HEIGHT }}
    >
      <OverbookingsBarTooltips duration={duration} overbookingsWithThreshold={overbookingsWithThreshold} />
      <div
        className={css.overbookingFill}
        style={{ width, background: threshold?.color ?? "var(--Palette-error)" }}
      />
    </BasicBar>
  );
};
